import { render } from "./DocumentDetails.vue?vue&type=template&id=3b87b82b&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"

import "./DocumentDetails.vue?vue&type=style&index=0&id=3b87b82b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b87b82b"]])

export default __exports__